import { useSetAtom } from "jotai";
import { useMutation } from "@tanstack/react-query";
import { setSchemaAtom } from "../../../atoms/GlobalAtoms";
import useCloudPermissions from "../../../hooks/useCloudPermissions";
import {
  callFunctionIfExists,
  getErrorMessage,
} from "../../../utils/GeneralUtils";
import TenantAPI from "../../api/TenantAPI";

const useUpdateRecordNameTemplate = () => {
  const setSchema = useSetAtom(setSchemaAtom);
  const { cPermissions } = useCloudPermissions();

  const onSuccessFunc = (data: any, onSuccess?: () => void) => {
    setSchema(data.data.data.schema);
    callFunctionIfExists(onSuccess);
  };

  const updateRecordNameTemplate = useMutation({
    mutationFn: ({
      moduleAPIName,
      recordNameTemplate,
      recordNameImage,
      recordNameMetadata,
      onSuccess,
    }: {
      moduleAPIName: string;
      recordNameTemplate: any;
      recordNameImage: string;
      recordNameMetadata: string;
      onSuccess?: () => void;
    }) => {
      if (!cPermissions.cloud_modify_template) {
        return Promise.reject("You do not have permission to create templates");
      }

      if (recordNameTemplate !== undefined) {
        return TenantAPI.modifyRecordNameTemplate(
          moduleAPIName,
          recordNameTemplate
        ).then((data) => onSuccessFunc(data, onSuccess));
      } else if (recordNameMetadata !== undefined) {
        return TenantAPI.modifyRecordNameMetadata(
          moduleAPIName,
          recordNameMetadata
        ).then((data) => onSuccessFunc(data, onSuccess));
      } else {
        return TenantAPI.modifyRecordNameImage(
          moduleAPIName,
          recordNameImage
        ).then((data) => onSuccessFunc(data, onSuccess));
      }
    },
  });

  return {
    updateRecordNameTemplate: updateRecordNameTemplate.mutate,
    updatingRecordNameTemplate: updateRecordNameTemplate.isPending,
    updateRecordNameTemplateError: updateRecordNameTemplate.error
      ? getErrorMessage(updateRecordNameTemplate.error)
      : null,
  };
};

export default useUpdateRecordNameTemplate;
